import { render, staticRenderFns } from "./FormInputReservationInputType.vue?vue&type=template&id=4fc5b472&scoped=true&lang=pug"
import script from "./FormInputReservationInputType.vue?vue&type=script&lang=ts"
export * from "./FormInputReservationInputType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputReservationInputType.vue?vue&type=style&index=0&id=4fc5b472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5b472",
  null
  
)

export default component.exports